import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective } from 'angular-datatables';
import { from, Subject } from 'rxjs';
import { LoaderComponent } from '../../servicios/loader/loader.component';
import { SeleccionService } from '../../servicios/seleccion.service';
import { ToolsService } from '../../recursos/tools.service';
import { IngresoService } from '../../servicios/ingreso.service';
import { AlertifyService } from 'src/app/recursos/alertify.service';

@Component({
  selector: 'app-becas-tipo-operario',
  templateUrl: './becas-tipo-operario.component.html',
  styleUrls: ['./becas-tipo-operario.component.css']
})
export class BecasTipoOperarioComponent implements OnInit {

  public mr: NgbModalRef;
  @ViewChild(DataTableDirective)
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  public dtTrigger: Subject<any>;

  public vecBecas = []; public vecDetBecas = [];
  public vecAddBecas = []; public tituloModal: string; private accion: number;

  constructor(private cargando: LoaderComponent, private srvSelect: SeleccionService, private tools: ToolsService,
    private modalService: NgbModal, private srvInsert: IngresoService, private alerti: AlertifyService) { }

  ngOnInit() {
    this.dtOptions[0] = this.tools.OpcionesTabla(10);
    this.dtTrigger = new Subject();
    this.cargarTipoBecas(1);
    this.cargarBecas();
  }
  //FUNCION QUE CARGA TODOS LOS DETALLES DE BECAS REGISTRADOS CON ESTADO ACTIVO
  async cargarBecas() {
    this.vecDetBecas = [];
    const res = await new Promise<any>(resolve =>
      this.srvSelect.gestionBecas(6, "na", "na", "na").subscribe(translated => {
        resolve(translated)
      }));
    if (res.success) {
      for (let i in res.becas) {
        this.vecDetBecas.push({
          idBeca: res.becas[i]['intIdBecas'], nombre: res.becas[i]['strNombre'], detalle: res.becas[i]['strDescripcion']
        });
      }
    }
  }
  //FUNCION QUE CARGA TODOS LOS ROLES REGISTRADOS EN EL SISTEMA
  async cargarTipoBecas(op) {
    this.reiniciarTabla();

    this.vecBecas = [];
    const res = await new Promise<any>(resolve =>
      this.srvSelect.gestionBecas(5, "na", "na", "na").subscribe(translated => {
        resolve(translated)
      }));
    if (res.success) {
      for (let objBeca of res.becas) {
        if (op == 1) {
          if (objBeca.intEstado == 1) {
            this.vecBecas.push({
              idTipoBeca: objBeca.intIdTipoBecas, nombre: objBeca.strNombre, detalle: objBeca.strDescripcion, idBeca: objBeca.intBeca, beca: objBeca.beca,
              estado: objBeca.intEstado == 1 ? "Activo" : "Inactivo", etiqueta: objBeca.intEstado == 1 ? "Desactivar" : "Activar"
            });
          }
        }
        else {
          this.vecBecas.push({
            idTipoBeca: objBeca.intIdTipoBecas, nombre: objBeca.strNombre, detalle: objBeca.strDescripcion, idBeca: objBeca.intBeca, beca: objBeca.beca,
            estado: objBeca.intEstado == 1 ? "Activo" : "Inactivo", etiqueta: objBeca.intEstado == 1 ? "Desactivar" : "Activar"
          });
        }
      }
    }
    this.dtTrigger.next();
    this.cargando.cerrar();
  }
  //FUNCION QUE ABRE EL MODAL PARA AGREGAR UN NUEVA BECA
  async modalNuevaBeca(nameMod) {
    if (localStorage.getItem('insUser') == 'true') {
      this.tituloModal = "Ingresar un nuevo tipo de beca"; this.accion = 7;
      this.borrarDatos();
      this.mr = this.modalService.open(nameMod);
    }
    else
      this.alerti.error("Este perfil no tiene permiso para esta actividad");
  }
  //FUNCION PARA ABRIR EL MODAL QUE PERMITE EDITAR UN TIPO DE BECA
  modalModBecas(nameMod, objRol) {
    if (localStorage.getItem('modUser') == 'true') {
      this.tituloModal = "Modificar el tipo de la beca"; this.accion = 8;
      this.buscarTipoBeca(objRol);
      this.mr = this.modalService.open(nameMod);
    }
    else
      this.alerti.error("Este perfil no tiene permiso para esta actividad");
  }
  //FUNCION QUE PERMITE AGREGAR O EDITAR UN TIPO DE BECA
  agregarTipoBeca() {
    this.srvInsert.ingresoGestionBecas(this.vecAddBecas[0]['idTipoBeca'], this.vecAddBecas[0]['nombre'], this.vecAddBecas[0]['detalle'],
      this.vecAddBecas[0]['estado'], this.vecAddBecas[0]['idBeca'], 'na', 'na', 'na', 'na', 'na', 'na', 'na', 'na', 'na', this.accion).subscribe(res => {
        if (res.becas) {
          if (this.accion == 7)
            this.buscarIdTipoBecas(this.vecAddBecas[0]['nombre'], 2);
          else
            this.agregarModulo(this.vecAddBecas[0]['nombre'], this.vecAddBecas[0]['estado'], this.vecAddBecas[0]['idTipoBeca'], 7);
          this.alerti.success('Tipo de beca registrada correctamente');
          this.cerrarModal();
          this.reiniciarTabla();
          this.cargarTipoBecas(1);
        }
        else
          this.alerti.error("No se pudo registrar la información.");
      });
  }
  //FUNCION QUE BUSCA EL ID DEL TIPO DE BECA
  async buscarIdTipoBecas(nombre, opc) {
    const res = await new Promise<any>(resolve =>
      this.srvSelect.gestionBecas(7, nombre, "na", "na").subscribe(translated => {
        resolve(translated)
      }));
    if (res.success) {
      this.agregarModulo(nombre, res.becas[0]['intEstado'], res.becas[0]['idBeca'], opc);
    }
  }
  //FUNCION QUE PERMITE INGRESAR O EDITAR LOS MODULOS DEL SISTEMA REGISTRADOS
  agregarModulo(nombre, estado, codigo, opcion) {
    this.srvInsert.ingresoGestionPermisos("na", nombre, estado, 'icono', codigo, 3, "na", "na", "na", "na", opcion).subscribe(res => {
      if (!res.permiso)
        this.alerti.error("No se puede agregar la actividad");
    });
  }
  //FUNCION PARA MOSTRAR LOS DATOS DEL TIPO DE LA BECA SELECCIONADA
  async buscarTipoBeca(tipoBeca) {
    this.cargando.abrir();
    this.vecAddBecas = [];
    const res = await new Promise<any>(resolve =>
      this.srvSelect.gestionBecas(8, tipoBeca['idTipoBeca'], 'na', 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (res.success) {
      this.vecAddBecas.push({
        idTipoBeca: res.becas[0]['intIdTipoBecas'], nombre: res.becas[0]['strNombre'], detalle: res.becas[0]['strDescripcion'],
        estado: res.becas[0]['intEstado'], idBeca: res.becas[0]['intBeca']
      });
    }
    else
      this.borrarDatos();
    this.cargando.cerrar();
  }
  //FUNCION PARA MODIFICAR EL ESTADO DE UN TIPO DE BECA
  cambiarEstado(beca) {
    if (localStorage.getItem('modUser') == 'true') {
      this.srvInsert.ingresoGestionBecas(beca['idTipoBeca'], beca['estado'] == "Activo" ? 2 : 1, 'na', 'na', 'na', 'na', 'na', 'na', 'na', 'na', 'na', 'na', 'na', 'na', 9).subscribe(res => {
        if (res.becas) {
          this.agregarModulo("na", beca['estado'] == "Activo" ? 2 : 1, beca['idTipoBeca'], 8)
          this.alerti.success('Estado editado correctamente');
          this.cargarTipoBecas(1);
        }
        else
          this.alerti.error("No actualizar el estado.");
      });
    }
    else
      this.alerti.error("Este perfil no tiene permiso para esta actividad");
  }
  //INSTANCIAR LAS VARIABLES 
  borrarDatos() {
    this.vecAddBecas = [];
    this.vecAddBecas.push({
      idTipoBeca: 0, nombre: "", detalle: "", estado: 1, idBeca: 1
    });
  }
  //FUNCION QUE ACTUALIZA LOS DATOS DE LA TABLA
  reiniciarTabla() {
    this.cargando.abrir(); var table3 = $('#tblBeca').DataTable({ destroy: true });
    table3.destroy();
  }
  //FUNCION QUE CIERRA EL MODAL
  cerrarModal() {
    this.mr.close();
  }
}
